import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useWorkspaceBadge } from '../workspace/WorkspaceProvider'
import { isDesktop, setDesktopBadge, setDesktopNavigator } from './desktopBridge'

/**
 * What the Shell tells the Desktop client (ADR 0033): the Workspace badge for
 * the app icon, and a way to open a chat when a notification is clicked.
 * Renders nothing, and does nothing in a browser.
 */
export function DesktopIntegration() {
  const badge = useWorkspaceBadge()
  const navigate = useNavigate()
  const desktop = isDesktop()

  useEffect(() => {
    if (!desktop) return
    setDesktopBadge(badge)
  }, [desktop, badge])

  useEffect(() => {
    if (!desktop) return
    return () => setDesktopBadge(0)
  }, [desktop])

  useEffect(() => {
    if (!desktop) return
    return setDesktopNavigator((to) => navigate(to))
  }, [desktop, navigate])

  return null
}
